import React from 'react';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-main section-wrap">
        <div>
          <a className="footer-brand" href="#top">AI Essay Help</a>
          <p className="footer-program">The Family Conversation</p>
        </div>
        <a className="footer-email" href="mailto:your-email@example.com">
          your-email@example.com
        </a>
      </div>
      <div className="footer-bottom section-wrap">
        <p>
          This training is for practice only and isn’t legal advice. Always confirm each school’s current AI policy on its admissions page.
        </p>
        <span>© {new Date().getFullYear()} AI Essay Help</span>
      </div>
    </footer>
  );
}

export default Footer;
